/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Nichtsepalaenderschluessel2Inputs */



/**

* @param {_Field_Nichtsepalaenderschluessel2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_nichtsepalaenderschluessel2 = /** @type {((inputs?: _Field_Nichtsepalaenderschluessel2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Nichtsepalaenderschluessel2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Nicht SEPA Laenderschluessel")
});
export { _field_nichtsepalaenderschluessel2 as "_field_nichtSepaLaenderschluessel" }